import { CustomAutoComplete, HorizontalForm } from '../../../../common/components';

const HistoricalProgressFilters = ({ projects, selectedProject, onProjectChange }) => {
  const projectOptions = (projects || []).map((project) => ({
    value: project.uuid,
    label: project.name || 'Proyecto sin nombre',
  }));

  return (
    <HorizontalForm>
      <CustomAutoComplete
        label="Proyecto"
        name="uuid_project"
        value={selectedProject || ''}
        onChange={onProjectChange}
        options={projectOptions}
        optionValueKey="value"
        optionLabelKey="label"
        placeholder="Seleccionar proyecto"
        size="medium"
        sx={{ maxWidth: '520px' }}
      />
    </HorizontalForm>
  );
};

export default HistoricalProgressFilters;
